import https from '../http';

//获取图形验证码
export const getVerifyCode = async params => {
  return await https.get('/yunqing/sso/verifyCode', params);
};
//获取手机验证码
export const getPhoneVerifyCode = async data => {
  return await https.post('/yunqing/sso/sendCode', data);
};
//获取手机验证码
export const ssoLogin = async data => {
  return await https.post('/yunqing/sso/login', data);
};
//获取手机验证码
export const ssoRegister = async data => {
  return await https.post('/yunqing/sso/register', data);
};
//获取ticket/token
export const getParam = async params => {
  return await https.get('/index/getParam', params);
};
//sso刷新用户token
export const refreshToken = async params => {
  return await https.get('/yunqing/sso/refreshToken', params);
};
//秒如同步登录状态
export const ssoTokens = async params => {
  return await https.get('/api/iam/v1/auth/sso/tokens', params, 'ai');
};
//sso用户退出登录
export const ssoOutLogin = async params => {
  return await https.get('/yunqing/sso/out-login', params);
};
